//this finds all sf videos injected with the ShortCodeHelper and hides the overlay while the video is playing

function init(){
    var videoPlayButton = $(".video__overlay.shortcode");

    videoPlayButton.each((index,element)=>{
        const el = $(element);
        el.on("click", function(){
            if (!el.hasClass("playing")) {
                el.addClass("playing");
                (el.children())[0].play();
            }
        });
    });

	// videoPlayButton.on("click", function (e) {
	// 	if (!videoPlayButton.hasClass("playing")) {
	// 		videoPlayButton.addClass("playing");
	// 		$(videoPlayButton.children())[0].play();
	// 	}
	// });
}

export { init }